const func = $target => {
	if ($target[0]) {
		/* add class to header on scroll - for mini version of header */
		if ($('body').hasClass('homepage')) {
			$(window).scroll(function() {
				var scroll = $(window).scrollTop();
				if (scroll >= 30) {
					$target.addClass('mini');
				} else {
					$target.removeClass('mini');
				}
			});
		}
		//megamenus
		$target.find('[data-mega]').each(function() {
			var $this = $(this);
			$this
				.on('mouseover', function(e) {
					$target.find('.megamenus [id]').addClass('d-none');
					$target.find($(this).attr('data-mega')).removeClass('d-none');
					$target.find('.megamenus').removeClass('d-none');
				})
				.on('click', function(e) {
					e.preventDefault();
				});
		});
		$target.on('mouseleave', function(e) {
			$target.find('.megamenus').addClass('d-none');
			$target.find('.megamenus [id]').addClass('d-none');
		});
	}
};

export default func;
